// Textos de disparo salvos (ate 50), leitura via RLS e escrita via RPC.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { mapRpcError } from "@/lib/rpc-error";

export interface BroadcastText {
  id: string;
  name: string;
  body: string;
}

const KEY = ["broadcast-texts"] as const;

const ERRORS: Readonly<Record<string, string>> = {
  broadcast_text_name_invalid: "Dê um nome de 1 a 60 caracteres.",
  broadcast_text_body_invalid: "O texto precisa ter de 1 a 2000 caracteres.",
  broadcast_text_limit_reached: "Limite de 50 textos salvos atingido.",
  broadcast_texts_plan_required: "Textos de disparo são do plano PRO.",
  broadcast_text_not_found: "Esse texto não existe mais.",
};

export function broadcastTextError(error: unknown): string {
  return mapRpcError(error, ERRORS, "Não foi possível salvar o texto.");
}

export function useBroadcastTexts() {
  return useQuery<BroadcastText[], Error>({
    queryKey: KEY,
    queryFn: async () => {
      const { data, error } = await supabase.from("broadcast_texts").select("id, name, body").order("created_at", { ascending: true });
      if (error) throw error;
      return (data ?? []) as BroadcastText[];
    },
    staleTime: 30_000,
  });
}

export function useSaveBroadcastText() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { id: string | null; name: string; body: string }) => {
      const { error } = await supabase.rpc("upsert_broadcast_text", { p_id: input.id, p_name: input.name, p_body: input.body });
      if (error) throw new Error(broadcastTextError(error));
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteBroadcastText() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.rpc("delete_broadcast_text", { p_id: id });
      if (error) throw new Error(broadcastTextError(error));
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
